import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import foodWarehouse from '../class/foodWarehouse';
import { formatRpcError } from '../class/jrpc20WSClient';
import swal from 'sweetalert';
import "../styles/ProductListPage.css";

// Sezione magazzino alimentare: lista degli ordini con componenti da prelevare.
// L'accesso e' gia' verificato da RequireQualifica (solo Magazzinieri).
const OrderListPage = () => {
    const [orders, setOrders] = useState([]);
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const fw = new foodWarehouse();
            const callData = await fw.getOrders();
            const orderList = callData?.orders || (Array.isArray(callData) ? callData : []);
            setOrders(orderList);
        } catch (error) {
            console.error("Error fetching the data", error);
            swal("Errore", formatRpcError(error), "error");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formatDate = (ts) => {
        if (!ts) return '-';
        return moment.unix(Number(ts)).format('DD/MM/YYYY');
    };

    const handleRowClick = (order) => {
        navigate(`/orders/${order.order_uuid}`);
    };

    const q = search.trim().toLowerCase();
    const filteredOrders = q === '' ? orders : orders.filter(order =>
        [order.order_production_number, order.article_code, order.article_descr]
            .some(v => String(v ?? '').toLowerCase().includes(q))
    );

    return (
        <div className="product-list-page">
            <div className="page-header">
                <h2 className='page-title'>Ordini da Prelevare</h2>
                <input
                    type="text"
                    className="order-search-input"
                    placeholder="Cerca per ordine, codice o articolo..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <div className="product-list">
                <div className="product-item">
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th>N. Ordine Produzione</th>
                                <th>Cliente</th>
                                <th>Codice Articolo</th>
                                <th>Articolo</th>
                                <th>Stato</th>
                                <th>Data Consegna</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOrders.map(order => (
                                <tr className='order' key={order.order_uuid} onClick={() => handleRowClick(order)} style={{ cursor: 'pointer' }}>
                                    <td>{order.order_production_number}</td>
                                    <td>{order.client_name}</td>
                                    <td>{order.article_code}</td>
                                    <td>{order.article_descr}</td>
                                    <td>{order.status_label}</td>
                                    <td>{formatDate(order.delivery_requested_date)}</td>
                                </tr>
                            ))}
                            {filteredOrders.length === 0 && (
                                <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>{q !== '' ? 'Nessun ordine trovato' : 'Nessun ordine da prelevare'}</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OrderListPage;
